module.exports = __webpack_public_path__ + "static/senyorial-story-thumbnail-6607ebd0873f952fef2f5a74574ce29b.png";